import styled from 'styled-components';
import { colors, fontWeight } from '@grnhse/seedling/lib/azalea/constants';

export const ContentBody = styled.div`
  line-height: 22px;
  font-size: 14px;
  ${fontWeight('normal')};
`;

export const ContentHeader = styled(ContentBody)`
  ${fontWeight('heavy')};
`;

export const ContentDescription = styled(ContentBody)`
  color: ${colors.mediumGrey};
`;

export const ContentBodyEmpty = styled(ContentBody)`
  color: ${colors.mediumGrey};
  font-style: italic;
`;

export const ContentContainer = styled.div`
  margin-bottom: 24px;
`;

export const SmallContentContainer = styled.div`
  margin-bottom: 8px;
`;

export const Content = styled.div`
  max-width: 695px;
`;
